<template>
  <div class="help_activity_rank_list">
    <div class="base_back_btn" v-if="backBtn" @click="$router.go(-1)">
      <span>返回</span>
    </div>
    <div class="container" :style="{ backgroundImage: `url('${containerBg}')` }">
      <div class="top_3">
        <img :src="rankList[2] && rankList[2].headImage" />
        <img :src="rankList[0] && rankList[0].headImage" />
        <img :src="rankList[1] && rankList[1].headImage" />
      </div>
      <div class="mine" v-if="form.userId">
        <div class="mine_title">
          <span>您当前的排名</span>
          <span class="mine_title_number">{{ form.rank }}</span>
        </div>
        <div class="mine_container">
          <div class="share_info">
            <div class="share_profile">
              <img
                :src="
                  form.headImage ||
                  defaultHeadPortrait
                "
                alt=""
              />
              <div class="share_name">
                <p class="share_name_school ellipsis">{{ form.schoolName }}</p>
                <p class="share_name_club ellipsis">{{ form.groupName }}</p>
              </div>
            </div>
            <div class="rank_quantity">{{ form.likeCount }}</div>
          </div>
        </div>
      </div>
      <div class="rank_list">
        <div class="rank_list_container">
          <div class="rank_item_container share_info" v-for="item in rankList" :key="item.id">
            <div class="rank_item_container_left share_profile">
              <div class="rank_number">
                <img src="@/assets/help-activity/1@2x.png" v-if="item.rank === '1'" />
                <img src="@/assets/help-activity/2@2x.png" v-else-if="item.rank === '2'" />
                <img src="@/assets/help-activity/3@2x.png" v-else-if="item.rank === '3'" />
                <span v-else>{{ item.rank }}</span>
              </div>
              <img
                :src="
                  item.headImage ||
                  defaultHeadPortrait
                "
                alt=""
              />
              <div class="share_name ellipsis">
                <div class="share_name_school ellipsis">{{ item.schoolName }}</div>
                <div class="share_name_club ellipsis">{{ item.groupName }}</div>
              </div>
            </div>
            <div class="rank_quantity">{{ item.likeCount }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="awards_show" @click="dialog = true">奖励说明</div>
    <van-popup v-model="dialog">
      <div class="btn_container">
        <img class="doalog_close" src="@/assets/help-activity/close@2x.png" @click="dialog = false" />
      </div>
      <div class="awards_show_dialog" v-html="contentHtml">
        <!-- <div class="awards_show_dialog_container">
          <div class="end_time">【统计截止时间】2021年10月31日24点</div>
          <div style="padding-left: 5px;">
            <div class="awards_title">榜单前十奖励：</div>
            <p>第1名：1000元梦想基金</p>
            <p>第2名：800元梦想基金</p>
            <p>第3-5名：500元梦想基金</p>
            <p>第6-10名：200元梦想基金</p>
            <div class="awards_title">助力值奖励：</div>
            <p>5个助力值：求职大礼包</p>
            <p>10助力值：视频会员月卡（100份）</p>
            <p>50助力值：100元京东卡（50份）</p>
            <p>200助力值：300元京东卡（20份）</p>
            <p>400助力值：600元京东卡（10份）</p>
            <p>1000助力值：2000元梦想基金（5份）</p>
            <p>1500助力值：3000元梦想基金（3份）</p>
            <p>2000助力值以上：5000元梦想基金（1份）</p>
            <div class="awards_title">说明：</div>
            <p>1、榜单前十奖励说明：1-5名需200助力值以上，6-10名需100助力值以上。</p>
            <p>2、助力值奖励：仅可领取一项，以可领取奖励中价值最高为准。</p>
            <p>3、领取奖品请添加求职小队长微信：qiuzhixdz。</p>
          </div>
        </div> -->
      </div>
    </van-popup>
  </div>
</template>
<script>
import { listGroupBoard, getTaskInfoById } from "@/api";
export default {
  data () {
    return {
      form: {
        schoolName: '',
        groupName: '',
        headImage: '',
        likeCount: '',
      },
      rankList: [],
      defaultHeadPortrait: require('@/assets/help-activity/photo3@2x.png'),
      dialog: false,
      contentHtml: '',
      bannerUrlWide: '',
      containerBg: require('@/assets/help-activity/rank_list_bg@2x.png'),
      backBtn: true,
    }
  },
  async created () {
    window.pageYoffset = 1;
    document.documentElement.scrollTop = 1;
    document.body.scrollTop = 1;
    await this.getTaskInfoById();
    await this.listGroupBoard();
  },
  methods: {
    async listGroupBoard () {
      const postData = {
        pageNum: 1,
        pageSize: 100,
        taskId: this.$route.query.taskId,
        taskSenderId: this.$route.query.taskSenderId,
      };
      const res = await listGroupBoard(postData);
      if (res.data && res.data.errorCode == 200) {
        const data = res.data.data;
        this.rankList = data.boardList;
        this.form = data;
      } else {
        this.$notify({
          type: "warning",
          message: res.data.apiErrorMessage,
          duration: 3 * 1000,
        });
      };
    },
    async getTaskInfoById () {
      const res = await getTaskInfoById({}, this.$route.query.taskId);
      if (res.data && res.data.errorCode == 200) {
        const data = res.data.data;
        this.containerBg = data.bannerUrlWide;
        this.contentHtml = data.rewardDesc;
        if (data.status === 1) {
          this.backBtn = false;
        }
      } else {
        this.$notify({
          type: "warning",
          message: res.data.apiErrorMessage,
          duration: 3 * 1000,
        });
      };
    },
  }
};
</script>
<style lang="less" scope>
.help_activity_rank_list {
  height: 100%;
  overflow-y: auto;
  position: relative;

  .awards_show {
    position: absolute;
    width: 83px;
    line-height: 30px;
    font-size: 14px;
    text-align: center;
    letter-spacing: .5px;
    color: #fff;
    top: 12px;
    right: 0;
    border-radius: 15px 0 0 15px;
    background: linear-gradient(315deg, #F94729 0%, #FF9F53 100%);
  }

  .container {
    min-height: 100%;
    // background: #627fff url('../../assets/help-activity/rank_list_bg@2x.png') 0 0 no-repeat;
    background-color: #627fff;
    background-position: 0 0;
    background-repeat: no-repeat;
    background-size: 100%;
    padding-top: 100vw * 245 / 375;

    .top_3 {
      width: 100vw * 352 / 375;
      margin: 0 auto;
      height: 100vw * 123 / 375;
      background: url('../../assets/help-activity/top3@2x.png') 0 0 no-repeat;
      background-size: 100%;
      position: relative;

      img {
        position: absolute;
        border-radius: 50%;
        border: 2px solid #97caf3;
      }
      img:nth-child(1) {
        width: 100vw * 40 / 375;
        height: 100vw * 40 / 375;
        top: 100vw * 35 / 375;
        left: 100vw * 45 / 375;
      }
      img:nth-child(2) {
        width: 100vw * 60 / 375;
        height: 100vw * 60 / 375;
        top: 100vw * -15 / 375;
        left: 100vw * 144 / 375;
      }
      img:nth-child(3) {
        width: 100vw * 50 / 375;
        height: 100vw * 50 / 375;
        top: 100vw * 20 / 375;
        right: 100vw * 35 / 375;
      }
    }

    .mine {
      padding: 0 10px;

      .mine_title {
        color: #fff;
        height: 26px;
        line-height: 26px;
        background: linear-gradient(122deg, #4EA8FF 0%, #365AF7 100%);
        border-radius: 8px 8px 0 0;
        font-size: 12px;
        display: flex;
        align-items: center;
        padding: 0 15px;
        letter-spacing: .5px;

        .mine_title_number {
          font-size: 15px;
          padding-left: 10px;
        }
      }

      .mine_container {
        border-radius: 0 0 8px 8px;
        background: #fff;
        padding: 0 15px;
      }
    }

    .rank_list {
      padding: 10px;

      .rank_list_container {
        border-radius: 8px;
        background: #fff;
        padding: 0 15px;

        .rank_item_container {
          border-bottom: 1px solid #eee;

          .rank_item_container_left {
            padding-left: 10px;
          }
        }
      }
    }

    .share_info {
      padding: 12px 0;
      font-size: 16px;
      color: #333;
      font-family: 'FZSHUIY_CUJW--GB1-0', 'FZSHUIY_CUJW--GB1';
      display: flex;
      justify-content: space-between;
      align-items: center;
      overflow: hidden;
      .rank_number {
        width: 40px;
        span {
          margin-left: 5px;
        }
        img {
          width: 20px !important;
          height: 28px !important;
          border-radius: 0 !important;
        }
      }
      .rank_quantity {
        font-size: 14px;
        width: 50px;
        text-align: center;
      }
      .share_profile {
        display: flex;
        align-items: center;
        flex: 1;
        width: 0;
        .share_name {
          flex: 1;
          width: 0;
          padding-left: 15px;
          .share_name_school {
            font-size: 15px;
            font-weight: bold;
          }
          .share_name_club {
            font-size: 13px;
            color: #666;
          }
        }
        img {
          width: 45px;
          height: 45px;
          border-radius: 50%;
        }
      }
    }
  }

  .van-popup {
    width: 100vw * 335 / 375;
    padding: 10px 20px 0;
    background: transparent;
    .btn_container {
      position: relative;
      .doalog_close {
        position: absolute;
        z-index: 99;
        right: 0;
        top: -5px;
        width: 21px;
      }
    }
    .awards_show_dialog {
      height: 100vw * 509 / 375;
      background: url('../../assets/help-activity/awards_show_bg2@2x.png') 0 0 no-repeat;
      background-size: 100%;
      padding: 50px 20px 20px;
      box-sizing: border-box;
      font-size: 13px;
      .awards_show_dialog_container {
        height: 100%;
        overflow-y: auto;
        padding: 0 10px;
        .end_time {
          padding: 10px 0 3px;
        }
        .awards_title {
          font-weight: bold;
          padding: 12px 0 5px;
        }
        p {
          color: #666;
          line-height: 25px;
          word-break: break-all;
        }
      }
    }
  }
}
</style>
